import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "../utils/utils";
import { formatNumberForLocale, parseLocaleNumber } from "../utils/locale";
import Spinner from '../utils/spinner';

const CreateGame = () => {
    const [roomName, setRoomName] = useState("");
    const [balance, setBalance] = useState(0);
    const navigate = useNavigate();
    const token = localStorage.getItem('userToken');
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        const sanitizedRoomName = sanitizeInput(roomName.trim());

        if (!sanitizedRoomName || balance <= 0) {
            setError("Please fill out the form!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/create_game`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ admin: token, balance: parseLocaleNumber(balance), roomName: sanitizedRoomName })
            });

            const result = await response.json();
            if (result.game_id) {
                localStorage.setItem('gameId', result.game_id);
                localStorage.setItem('gameName', sanitizedRoomName);
                console.log("result.game_id" + result.game_id);
                navigate("/WaitingRoom");
            }

        } catch (error) {
            setError("Server error")
        }
    };

    return (
        <>
            <div className="card h-screen">
                <div className="sub-card mb-5">
                    <h1 className="wtext mb-1">
                        Priporočene vsote
                    </h1>
                    <ul className="grid grid-cols-2 gap-4">
                        {[
                            { label: "Jugo", value: 20000 },
                            { label: "Old", value: 20000 },
                            { label: "Unwanted", value: 200000 },
                            { label: "Bank sub-cards", value: 20000000 },
                        ].map(({ label, value }) => (
                            <li
                                key={label}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setBalance(value);
                                }}
                                className="cursor-pointer rounded-lg wtext border border-gray-700 p-2 text-center transition hover:border-gray-500 hover:bg-gray-700"
                            >
                                <p className="font-medium">{label}</p>
                                <p className="text-sm opacity-80">
                                    {formatNumberForLocale(value)}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="sub-card">
                    {error && <p className="text-red-500 mb-4">{error}</p>}
                    <h1 className="wtext mb-1">
                        Nastavitve
                    </h1>

                    <label htmlFor="balance" className="block text-lg wtext">Začetno stanje:</label>
                    <input type="text" name="balance" className="w-full mt-2 px-4 py-2"
                        id="balance" value={formatNumberForLocale(balance)} inputMode="numeric" onChange={(e) => {
                            setBalance(parseLocaleNumber(e.target.value))
                            setError(null)
                        }} />

                    <label htmlFor="roomName" className="block text-lg  mt-2 wtext">Ime sobe:  </label>
                    <input type="text" className="w-full mt-2 px-4 py-2"
                        name="roomName" id="roomName" onChange={(e) => { setRoomName(e.target.value); setError(null) }} />
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full py-3 rounded-lg shadow-md transition duration-300 mt-10"
                    >
                        Ustvari
                    </button>
                </div>
            </div>
        </>
    )
};

export default CreateGame;
